export default function urlContain(url) {
    let KEYWORD = "usedtractorstorage";
    let STAGING_KEYWORD = "castagingstorage";
    let SAS_TOKEN = "?sv=2021-12-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2026-04-01T14:30:38Z&st=2023-03-29T06:30:38Z&spr=https&sig=mk0i2ZPyaotRM5smvwnf9y9%2BcZljr9BrtLIK2%2FnnJ6k%3D";
    let STAGING_SAS_TOKEN = "?sp=r&st=2024-01-09T12:39:22Z&se=2026-01-09T20:39:22Z&spr=https&sv=2022-11-02&sr=c&sig=RSSuG4dCJR9eZUYu2otiWXya0Hq7FvtTxSl3lXcThvg%3D";
    
    return ( 
    (url?.indexOf(KEYWORD) !== -1) ? `${url}${SAS_TOKEN}` : (url?.indexOf(STAGING_KEYWORD) !== -1) ? `${url}${STAGING_SAS_TOKEN}` : url
    )
}
